import React, { useEffect, useState } from 'react'
import { getFullOrder } from 'api/order'
import { isOrderPast } from 'lib/order/isUpcoming'
import LesaPurchaseSummarySkeleton from '../../SelectPurchase/LesaPurchaseSummary/Common/LesaPurchaseSummarySkeleton'
import LesaPurchaseSummary from '../../SelectPurchase/LesaPurchaseSummary/LesaPurchaseSummary'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  meta: App.ChatMessageMeta
}

const ORDER_ACTIONS_WITH_LOADING = new Set([
  'listInclusions',
  'selectOrder',
  'selectOrderItem',
  'selectFlightOrder',
  'airportTransfersSelectOrder',
  'selectOrderItemExtraGuests',
  'selectOrderExtraGuests',
])

export default function MessageMetaComponents(props: Props) {
  const { meta } = props

  const [chatOrder, setChatOrder] = useState<App.Order | null>(null)

  const showOrderLoading = !chatOrder && meta?.payload?.id_orders && meta?.action && ORDER_ACTIONS_WITH_LOADING.has(meta.action)

  const EMPTY_COMPONENTS_MAP = new Map().set(meta?.action, {})

  useEffect(() => {
    if (meta?.payload?.id_orders) {
      getFullOrder(meta.payload.id_orders).then(setChatOrder)
    }
  }, [meta?.payload?.id_orders])

  if (showOrderLoading) {
    return <LesaPurchaseSummarySkeleton hideSelect />
  }

  if (chatOrder) {
    return (
      <LesaPurchaseSummary componentsMap={EMPTY_COMPONENTS_MAP} hideSelect actions={EmptyArray} order={chatOrder} isPastOrder={isOrderPast(chatOrder)} payload={meta?.payload} />
    )
  }

  return null
}
